import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import {
  Add as AddIcon,
  Archive as ArchiveIcon,
  FilterList as FilterListIcon,
  RemoveRedEye as RemoveRedEyeIcon,
} from "@mui/icons-material";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Divider as MuiDivider,
  Paper as MuiPaper,
  Typography,
  Button,
  CircularProgress,
  TextField,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  LinearProgress,
  Input,
  FormHelperText,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box, spacing } from "@mui/system";
import useAuth from "../../../hooks/useAuth";
import Grid from "@mui/system/Unstable_Grid";
import InputMask from "react-input-mask";
import TicketAddMessageBody from "./addMessage";
const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function TicketView(props) {
  let { getApi, admPostApi, admGetApi, admPutApi } = useAuth();

  const [message, setMessage] = useState("");

  const [status, setStatus] = useState(1);
  const [sendNotification, setSendNotification] = useState(true);
  const [internalNote, setInternalNote] = useState(false);
  const [statusList, setStatusList] = useState([]);

    const [internalRequest, setInternalRequest] = useState(false);


  const [loadingOnSave, setLoadingOnSave] = useState(false);
  const [bsAccount, setBsAccount] = React.useState([]);
  const [mainOperator, setMainOperator] = React.useState([]);
  const [accountRequestTypeId, setAccountRequestsTypeId] = React.useState(2);
  const [priority, setPriority] = React.useState(3);

  const [subjectText, setSubjectText] = React.useState("");

  let { bsid } = useParams();

  const LoadStatus = async () => {
    let response = await admGetApi("/tickets/status", {});
    setStatusList(response);
  };

  useEffect(() => {
    LoadStatus();
    LoadBsAccount();
  }, []);

  const LoadBsAccount = async () => {
    setBsAccount([]);
    let response = await admGetApi("/bsaccount/" + bsid, {});
    console.log(response);

    setBsAccount(response.business_account);
    setMainOperator(response.operator);
  };

  const [listUploadVal, setListUploadVal] = React.useState([]);

  const sendNotificationHandle = async () => {
    let files = [];
    listUploadVal.forEach((item, index, arr) => {
      files.push(item.file);
    });

    setLoadingOnSave(true);
    let response = await admPostApi("/tickets/create", {
      general_operators_id: mainOperator.id,
      general_business_account_id: bsAccount.id,
      account_requests_status_id: status,
      account_requests_type_id: accountRequestTypeId,
      subject: subjectText,
      internal_request:internalRequest,
      priority:priority,

      text: message,
      status: status,
      sendNotification: sendNotification,
      internal: internalNote,
      file: files,
    });
    alert("Ticket criado com sucesso.");
     window.location.href="/digital-account/tickets/id/"+   response.ticket.id;

    setLoadingOnSave(false);
  };

  return (
    <React.Fragment>
      <Helmet title="Contas de Negócios" />
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Ticket - Crie um novo ticket
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/">
              Dashboard
            </Link>
            <Link component={NavLink} to="/digital-account/tickets">
              Tickets
            </Link>
            <Typography>#</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Grid container justifyContent={"center"}>
        {bsAccount && (
          <Box
            height={120}
            my={4}
            display="flex"
            alignItems="center"
            gap={4}
            p={2}
            sx={{ border: "1px solid grey", width: "30%" }}
          >
            ID: {bsAccount.id} <br />
            Razão Social: {bsAccount.company_name} <br />
            Nome Fantasia: {bsAccount.fantasy_name} <br />
            CPF/CNPJ: {bsAccount.identifier} <br />
            Consultor: {bsAccount.consultant} <br />
          </Box>
        )}

        {mainOperator && (
          <Box
            height={120}
            my={4}
            display="flex"
            alignItems="center"
            gap={4}
            p={2}
            sx={{ border: "1px solid grey", width: "30%" }}
          >
            Operador: {mainOperator.fullname} <br />
            E-mail: {mainOperator.email} <br />
            CPF/CNPJ: {mainOperator.personal_tax_identifier} <br />
            Telefone: {mainOperator.phone} <br />
          </Box>
        )}
      </Grid>

      <Grid container justifyContent={"left"}>
        <Grid item md={12}>
          <FormControl variant="standard" fullWidth>
            <InputLabel htmlFor="component-simple">
              Assunto do ticket
            </InputLabel>
            <Input
              id="component-simple"
              defaultValue="Composed TextField"
              value={subjectText}
              onChange={(e) => setSubjectText(e.target.value)}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container justifyContent={"left"}>
        <Grid item md={4} sm={12} mt={4} lg={4}>
          <FormControl fullWidth variant="standard">
            <InputLabel id="Prioridade-label">Prioridade</InputLabel>
            <Select
              labelId="Prioridade-label"
              id="Prioridade"
              value={priority}
              label="Prioridade"
              onChange={(e) => setPriority(e.target.value)}
            >
              <MenuItem value={2}>Alta</MenuItem>
              <MenuItem value={1}>Imediata</MenuItem>
              <MenuItem value={3}>Média</MenuItem>
              <MenuItem value={4}>Baixa</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container justifyContent={"left"}>
        <Grid item md={4} sm={12} mt={4} lg={4}>
          <FormControl fullWidth variant="standard">
            <InputLabel id="tipo-label">Tipo</InputLabel>
            <Select
              labelId="tipo-label"
              id="tipo"
              value={accountRequestTypeId}
              label="Tipo"
              onChange={(e) => setAccountRequestsTypeId(e.target.value)}
            >
              <MenuItem value={1}>Cancelamento da conta</MenuItem>
              <MenuItem value={2}>Alteração de dados</MenuItem>
              <MenuItem value={3}>Análise da conta</MenuItem>
              <MenuItem value={4}>Análise de Transações</MenuItem>
              <MenuItem value={5}>Análise da Transferências</MenuItem>
              <MenuItem value={6}>Alterar Titularidade</MenuItem>
              <MenuItem value={7}>Erros, Bugs e ou melhorias</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container justifyContent={"left"}>
        <Grid item md={12} sm={12} mt={4} lg={5}>
          <InputLabel id="tipo-label">Ticket Interno</InputLabel>
          <FormControlLabel
            control={
              <Switch
                defaultChecked={internalRequest}
                onClick={(e) => setInternalRequest(!internalNote)}
              />
            }
            label="Ticket Interno"
          />
          <small>
            Todas as mensagens criadas estarão disponível apenas internamente.
          </small>
        </Grid>

        <Grid container justifyContent={"left"}>
          <TicketAddMessageBody
            loadingOnSave={loadingOnSave}
            statusList={statusList}
            message={message}
            setMessage={setMessage}
            status={status}
            setStatus={setStatus}
            sendNotification={sendNotification}
            setSendNotification={setSendNotification}
            sendNotificationHandle={sendNotificationHandle}
            internalNote={internalNote}
            setInternalNote={setInternalNote}
            setListUploadVal={setListUploadVal}
            listUploadVal={listUploadVal}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default TicketView;
